import { render, staticRenderFns } from "./stockMovementsTable.vue?vue&type=template&id=c7032732&"
import script from "./stockMovementsTable.vue?vue&type=script&lang=ts&"
export * from "./stockMovementsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports